import upload from './upload'

export default [upload]
